import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
Sentry.init({
    dsn: "https://40467af232094349a7472b0e24791818@o90177.ingest.sentry.io/5456697",
    release: "tms@" + process.env.npm_package_version,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0, // We recommend adjusting this in production
});
